import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FlashMessagesService } from 'angular2-flash-messages';
import { TextMaskModule } from 'angular2-text-mask';
import { RealPipe } from 'ng2-brpipes/src/real.pipe';
import { ConfirmComponent } from '../../../../shared/confirm/confirm.component';

export interface EditLCModal {
  ContaClienteId: string;
  limiteYara: number;
  vigenciaYara: Date;
  limiteGalvani: number;
  vigenciaGalvani: Date;
}

@Component({
  selector: 'app-edit-lc',
  templateUrl: './edit-lc.component.html',
  styleUrls: ['./edit-lc.component.scss'],
  providers: [
    RealPipe
  ]
})
export class EditLcComponent extends DialogComponent<EditLCModal, any> implements OnInit, EditLCModal {

  // Model Bind Fields
  ContaClienteId: string;
  limiteYara: number;
  vigenciaYara: Date;
  limiteGalvani: number;
  vigenciaGalvani: Date;

  // Computed Fields
  limiteAtualYara: number;
  vigenciaFimYara: Date;
  limiteAtualGalvani: number;
  vigenciaFimGalvani: Date;
  total: number;

  public currentDate = moment(new Date(new Date().setHours(0, 0, 0, 0))).format("YYYY-MM-DD HH:mm:ss");
  public currentDateObject = moment(new Date(new Date().setHours(0, 0, 0, 0))).toDate();

  constructor(dialogService: DialogService, private flashMessagesService: FlashMessagesService, private realPipe: RealPipe) {
    super(dialogService);
  }

  get limiteYaraCorrigido() {
    return (this.vigenciaFimYara && this.currentDateObject > this.vigenciaFimYara ? 0 : this.limiteYara);
  }

  get limiteGalvaniCorrigido() {
    return (this.vigenciaFimGalvani && this.currentDateObject > this.vigenciaFimGalvani ? 0 : this.limiteGalvani);
  }

  ngOnInit() {
    this.vigenciaFimYara = moment(this.vigenciaYara).toDate();
    this.vigenciaFimGalvani = moment(this.vigenciaGalvani).toDate();
    this.limiteAtualYara = this.limiteYara;
    this.limiteAtualGalvani = this.limiteGalvani;

    // Ignorar limite que não é vigente na soma do Total
    this.total = this.limiteYaraCorrigido +
                 this.limiteGalvaniCorrigido;
  }

  mask(): any {
    return {
      mask: (value) => {
        const mask = [];
        const values = value.split('');

        values.forEach(() => {
          mask.push(/[\d]/);
        });

        return mask;
      },
      guide: false
    };
  }

  confirm() {
    const retorno = {
      ContaClienteId: this.ContaClienteId,
      LimiteYara: +this.limiteYaraCorrigido,
      LimiteGalvani: +this.limiteGalvaniCorrigido
    };

    console.log(retorno);

    if (retorno.LimiteYara + retorno.LimiteGalvani > this.total) {
      this.flashMessagesService.show(`Valor superior ao total de ${this.realPipe.transform(this.total)}.`, { cssClass: 'alert-danger', timeout: 6000 });
    } else if (retorno.LimiteYara + retorno.LimiteGalvani < this.total) {
      let disposable = this.dialogService.addDialog(ConfirmComponent, {
        title: 'Confirmar',
        message: 'O LC Total será reduzido. Gostaria de prosseguir?'
      },
      { backdropColor: 'rgba(0, 0, 0, 0.5)' }
      ).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.save(retorno);
        }
      });

      setTimeout(() => {
        disposable.unsubscribe();
      }, 15000);
    } else {
      this.save(retorno);
    }
  }

  save(retorno) {
    this.result = retorno;
    this.close();
  }

  canSave() {
    return (
      (!this.vigenciaFimYara && !this.vigenciaFimGalvani)
      || ((this.vigenciaFimYara && this.currentDateObject > this.vigenciaFimYara) && (this.vigenciaFimGalvani && this.currentDateObject > this.vigenciaFimGalvani))
      || (this.limiteYara === this.limiteAtualYara && this.limiteGalvani === this.limiteAtualGalvani));
  }
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/edit-lc/edit-lc.component.ts